import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import SolidPlaneDepartureIcon from 'LuxKit/Icons/solid/SolidPlaneDepartureIcon'
import Colour from 'components/utils/Colour'
import LuxPlusMonthTakeoverBackground from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthTakeoverBackground'
import useLuxPlusFlightVoucherBanner from 'luxPlus/hooks/useLuxPlusFlightVoucherBanner'
import { LUX_PLUS_FLIGHT_VOUCHER_CAMPAIGN } from 'luxPlus/constants/base'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import styled from 'styled-components'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

const Background = styled(LuxPlusMonthTakeoverBackground)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

function useLuxPlusFlightVoucherOfferBannerItem(): PageBannerCarouselItem | null {
  const {
    showBanner,
    onDismiss,
    ctaLabel,
    ctaTo,
    ctaHref,
    ctaOnClick,
  } = useLuxPlusFlightVoucherBanner()

  return useMemo(() => {
    if (!showBanner) return null

    return {
      id: 'luxplus-flight-voucher-offer',
      kind: 'lux-plus',
      icon: <SolidPlaneDepartureIcon size="M" />,
      onDismiss,
      customBackground: <Background />,
      actionButtonProps: {
        kind: 'secondary',
        children: ctaLabel,
        to: ctaTo,
        href: ctaHref,
        onClick: ctaOnClick,
      },
      children: <FormattedMessage
        id="MGr61m5lxWxt7i7j-Fli"
        defaultMessage="<luxPlusLabel>LuxPlus<plus>+</plus></luxPlusLabel> members save up to $800 on international return flights with exclusive flights vouchers, redeemable at checkout. Ends {endDate}. T&Cs Apply."
        description="LuxPlus+ flight voucher promotional banner message"
        values={{
          luxPlusLabel: chunks => <b>{chunks}</b>,
          plus: chunks => <Colour value="highlight-lux-plus">{chunks}</Colour>,
          endDate: <FormatDateTime value={LUX_PLUS_FLIGHT_VOUCHER_CAMPAIGN.END_DATE} day="numeric" month="short" year="numeric" />,
        }}
      />,
    }
  }, [showBanner, onDismiss, ctaLabel, ctaTo, ctaHref, ctaOnClick])
}

export default useLuxPlusFlightVoucherOfferBannerItem
